import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

import { PageHeader } from "../../../../layout/components";

export const detailsHeaderContainer = css`
    width: 100%;
`;

export const stringsContainer = css`
    width: 100%;
    padding-bottom: ${Spacing.MD}px;
`;

export const button = css`
    margin-left: auto;

    span {
        font-size: ${FontSizeInPx.REGULAR}px;
        font-weight: ${FontWeight.NORMAL};
    }
`;

export const loadableContainer = css`
    width: 100%;
`;

export const PageTitle = styled(PageHeader)`
    flex: 1;
    flex-shrink: 0;
    width: 150px;
    margin-right: ${Spacing.MD}px;
`;
